import config from "@shared/config/server";
import { RequestBuilder } from "./requestBuilder";
import { getBlockchain, getToken } from "@/utilities/server";

export class ServerRequestBuilder<T> extends RequestBuilder<T> {
  constructor(url?: string, signal?: AbortSignal);
  constructor(
    callback: (requestInit: RequestInit) => Promise<T>,
    signal?: AbortSignal,
  );

  constructor(
    arg: string | ((requestInit: RequestInit) => Promise<T>) | undefined,
    signal?: AbortSignal,
  ) {
    super(arg, signal);
  }

  public async getBlockchain() {
    return await getBlockchain();
  }

  public async authenticate() {
    const token = await getToken();

    this.requestInit = {
      ...this.requestInit,
      headers: {
        ...this.requestInit?.headers,
        Cookie: `${config.cookies.token}=${token}`,
      },
    };

    return this;
  }

  public override async call(
    url?: string,
    updateRequestInit?: (init: RequestInit) => RequestInit,
  ) {
    return super.call(url, updateRequestInit);
  }
}
